import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import { connect } from 'react-redux';
import { compose, lifecycle, branch, renderComponent } from 'recompose';
import queryString from 'query-string';
import JobViewer from './containers/JobViewer';
import {
  setJobId,
  setTicketId,
} from './actions';

import PageLayout from '../../layouts/PageLayout';
import { getTicketId, getJobId } from './selectors';
import { routerProps } from '../../propTypes';
import { setShowHeader } from '../../app/actions';
import { getShowHeader } from '../../app/selectors';

const propTypes = exact({
  ticketId: PropTypes.number,
  jobId: PropTypes.number.isRequired,
  showHeader: PropTypes.bool.isRequired,
  setJobIdAction: PropTypes.func.isRequired,
  setTicketIdAction: PropTypes.func.isRequired,
  setShowHeaderAction: PropTypes.func.isRequired,
  ...routerProps,
});


const page = (props) => {
  const { ticketId, jobId, showHeader } = props;
  return (
    <PageLayout
      title="Job Viewer"
      showHeader={showHeader}
      render={() => { return <JobViewer jobId={jobId} ticketId={ticketId} />; }}
    />
  );
};


const mapStateToProps = (state) => {
  return {
    ticketId: getTicketId(state),
    jobId: getJobId(state),
    showHeader: getShowHeader(state),
  };
};

const mapDispatchToProps = {
  setTicketIdAction: setTicketId,
  setJobIdAction: setJobId,
  setShowHeaderAction: setShowHeader,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoTicketId = branch(
  (props) => {
    return (props.jobId === null);
  },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        No Job Id Provided
      </div>
    );
  }),
);

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      location,
    } = this.props;

    const { setJobIdAction, setTicketIdAction, setShowHeaderAction } = this.props;
    const querySringObject = queryString.parse(location.search);
    const { ticketId, showHeader } = querySringObject;

    const { match: { params: { jobId } } } = this.props;

    if (jobId) {
      const jobIdValue = parseInt(jobId, 10);
      setJobIdAction(jobIdValue);
    }

    if (ticketId) {
      const ticketIdValue = parseInt(ticketId, 10);
      setTicketIdAction(ticketIdValue);
    }

    if (showHeader !== undefined) {
      setShowHeaderAction(showHeader);
    }
  },
});

const enhance = compose(
  withRedux,
  withInitPage,
  withNoTicketId,
);

page.propTypes = propTypes;

export default enhance(page);
